export default __webpack_public_path__ + "static/b_radler_01-19f1314149adc6370a061796ac61e415.png";